// src/index.js
import "./index.css";
import App from "./App.js";
import { createRoot } from "react-dom/client";
import i18next from "./i18n.js";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import React, { Suspense } from "react";
import Loader from "./components/Loader";

const Root = () => (
  <I18nextProvider i18n={i18next}>
    <HelmetProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </Router>
    </HelmetProvider>
  </I18nextProvider>
);

const container = document.querySelector("#root");
const root = createRoot(container);

root.render(
  <Suspense fallback={<Loader />}>
    <Root />
  </Suspense>
);
